function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevLightMode = function SvgDevLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 456.54 456.54",
    style: {
      enableBackground: "new 0 0 456.54 456.54"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffde55"
    },
    d: "M215.27 379.3h26v77.24h-26zM215.27 0h26v77.24h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-134.999 94.169 362.372)",
    style: {
      fill: "#fceba2"
    },
    d: "M81.169 323.75h26v77.239h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-134.999 362.373 94.165)",
    style: {
      fill: "#fceba2"
    },
    d: "M349.372 55.544h26v77.239h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffde55"
    },
    d: "M0 215.27h77.24v26H0zM379.3 215.27h77.24v26H379.3z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 94.168 94.169)",
    style: {
      fill: "#fceba2"
    },
    d: "M81.169 55.548h26v77.239h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 362.375 362.379)",
    style: {
      fill: "#fceba2"
    },
    d: "M349.378 323.753h26v77.239h-26z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fceba2"
    },
    cx: 228.267,
    cy: 228.271,
    r: 124.003
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffde55"
    },
    cx: 228.267,
    cy: 228.271,
    r: 95.142
  }));
};
export default SvgDevLightMode;